__turbopack_context__.v({
  "animatedExpanderContent": "SPwGmq_animatedExpanderContent",
});
